module.exports = __webpack_public_path__ + "static/media/ios.9fb69548.png";